import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Concept from "./components/Concept";
import ProductSection from "./components/ProductSection";
import Features from "./components/Features";
import Products from "./components/Products";
import News from "./components/News";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

export default function Home() {
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 150);
      }
    }
  }, [hash]);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-100">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Concept />
        <Features />
        <ProductSection />
        <Products />
        <News />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}